import { render, staticRenderFns } from "./ViewBids.vue?vue&type=template&id=319c93c6&"
import script from "./ViewBids.vue?vue&type=script&lang=js&"
export * from "./ViewBids.vue?vue&type=script&lang=js&"
import style0 from "./ViewBids.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports